export default __webpack_public_path__ + "static/media/solicitud-aceptada.50d68d76.svg";